/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import { ButtonFillXLarge } from "components/shared/SpectrumCss";
import "stylesheets/spectrum.scss";

export const HomePageButton = styled(ButtonFillXLarge).attrs({
  className: "spectrum-Button--accent",
})`
  width: 170px;
  height: 48px;
  padding: 10px 24px;
  color: white;
  display: flex;
  justify-content: space-evenly;
`;
